export default __webpack_public_path__ + "static/media/logo.e3289aa9.png";